import moment from 'moment-mini';

export default {
  numberWithTwoDecimals(val) {
    const { locale } = window.vue.$store.state;
    const withDecimals = parseFloat(val) / 100;
    let n = null;

    const minimumFractionDigits = 2;

    if (typeof Intl !== 'undefined') {
      n = new Intl.NumberFormat(locale, {
        minimumFractionDigits,
      }).format(withDecimals);
      return n;
    }
    return `${withDecimals.toFixed(minimumFractionDigits)}`;
  },
  currency(val) {
    const { locale } = window.vue.$store.state;
    const currency = window.vue.$store.state.app.currencySymbol;
    const n = this.numberWithTwoDecimals(val);
    if (locale === 'de-CH') {
      return `${currency} ${n}`;
    }
    return `${n} ${currency}`;
  },
  percentage(val) {
    const n = this.numberWithTwoDecimals(val * 100);
    return `${n} %`;
  },
  time(t) {
    return moment(t).format('HH:mm');
  },
  date(d) {
    return moment(d).format('DD.MM.YYYY');
  },
  dateTime(d) {
    const dt = moment(d);
    return dt.format('DD.MM.YYYY HH:mm');
  },
};
